import { Refresh } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
import { hasPermission } from "utils/permissionUtils";

export const ImageName = (text) => {
  const splittedText = text?.split(" ");
  return (
    text && (
      <span className="font-bold uppercase text-xl rounded-full bg-app-surface-alt w-10 h-10 flex items-center justify-center text-center">
        {splittedText
          ?.map((word) => word.charAt(0))
          .join("")
          .slice(0, 2)}
      </span>
    )
  );
};

export { convertDateFormat } from "utils/dateFormat";

export const RefreshData = ({ refreshData, className }) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await refreshData();
    } finally {
      setTimeout(() => {
        setIsRefreshing(false);
      }, 1000);
    }
  };

  return (
    <Tooltip title="Refresh Data">
      <IconButton
        onClick={handleRefresh}
        disabled={isRefreshing}
        className={`relative ${className}`}
      >
        <Refresh
          className={`transition-transform duration-300 ${isRefreshing ? "animate-spin" : ""}`}
          style={{
            animation: isRefreshing ? "spin 1s linear infinite" : "none",
          }}
        />
        <style>
          {`
            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
          `}
        </style>
      </IconButton>
    </Tooltip>
  );
};

export const eventClick = (event) => {
  const isActionClick =
    event.target.closest(".MuiIconButton-root") ||
    event.target.closest(".MuiPopover-root") ||
    event.target.closest(".MuiAutocomplete-root") ||
    event.target.closest(".MuiPopper-root") ||
    // event.target.closest(".MuiPaper-root") ||
    event.target.closest(".MuiList-root") ||
    event.target.closest(".MuiMenuItem-root") ||
    event.target.closest(".uniButton");

  return isActionClick;
};

export const truncateText = (text, maxLength) => {
  return text?.length > maxLength ? `${text?.substring(0, maxLength)}...` : text;
};

export const checkPermission = (permission) => {
  return hasPermission(permission);
};
